/* eslint-disable react/prop-types */

import React, { useRef, useState } from 'react';
import Dropdown from '@/components/common/Dropdown';
import { TCITooltip } from '@/components/ui/Tooltip';
import * as Routes from '@/modules/routes';
import styles from './HelpButton.module.scss';
import FeedbackForm, { IStaffer } from './FeedbackForm';

type HelpButtonProps = {
  currentPageUrl: string;
  helpIconUrl: string;
  programId: string,
  hasPdCourse: boolean;
  staffer: IStaffer;
};

const HelpButton = ({
  currentPageUrl,
  helpIconUrl,
  hasPdCourse,
  programId,
  staffer,
}: HelpButtonProps) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const closeTimerRef = useRef<number>();

  const cancelClose = () => {
    window.clearTimeout(closeTimerRef.current);
  };
  const scheduleClose = () => {
    cancelClose();
    closeTimerRef.current = window.setTimeout(() => setTooltipOpen(false), 150);
  };
  // The menu renders inside the tooltip trigger, so any hover within it — including
  // Radix's own trigger handlers — would otherwise raise the tooltip over the menu.
  const setTooltipOpenUnlessMenuOpen = (next: boolean) => {
    if (next && menuOpen) return;
    setTooltipOpen(next);
  };
  const openNow = () => {
    cancelClose();
    setTooltipOpenUnlessMenuOpen(true);
  };
  const handleMenuOpenChange = (open: boolean) => {
    setMenuOpen(open);
    if (open) {
      cancelClose();
      setTooltipOpen(false);
    }
  };

  return (
    <TCITooltip open={tooltipOpen} side="bottom" onOpenChange={setTooltipOpenUnlessMenuOpen}>
      <TCITooltip.Trigger asChild>
        <span
          className="tw-flex"
          onBlurCapture={scheduleClose}
          onFocusCapture={openNow}
          onMouseDownCapture={() => { cancelClose(); setTooltipOpen(false); }}
          onMouseEnter={openNow}
          onMouseLeave={scheduleClose}
        >
          <Dropdown
            ariaLabel="Support"
            buttonClass={`${styles.helpButton} btn btn--link-white`}
            containerClass={styles.helpContainer}
            dropdownClass={styles.dropdownHelpButton}
            dropdownPosition="bottom"
            menuRole={false}
            toggleText={(
              <img
                alt=""
                src={helpIconUrl}
                tabIndex={-1}
              />
              )}
            onOpenChange={handleMenuOpenChange}
          >
            <ul className={styles.helpList}>
              <li>
                <a
                  className="dropdown-item purple !tw-text-base"
                  href="https://help.teachtci.com/s/"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Help
                </a>
              </li>
              <li>
                <FeedbackForm
                  className="tw-font-tci !tw-text-base !tw-text-tci-purple"
                  currentPageUrl={currentPageUrl}
                  staffer={staffer}
                />
              </li>
              {hasPdCourse && !!programId && (
                <li>
                  <a
                    className="dropdown-item purple !tw-text-base"
                    href={Routes.teacher_program_professional_developments_path(programId)}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Professional Development
                  </a>
                </li>
              )}
            </ul>
          </Dropdown>
        </span>
      </TCITooltip.Trigger>
      <TCITooltip.Content
        onMouseEnter={openNow}
        onMouseLeave={scheduleClose}
      >
        Support
      </TCITooltip.Content>
    </TCITooltip>
  );
};

export default HelpButton;
